export const UNSAVED_CHANGES_NAMED_INIT = "UNSAVED_CHANGES_NAMED_INIT";
export const UNSAVED_CHANGES_NAMED_SUCCESS = "UNSAVED_CHANGES_NAMED_SUCCESS";
export const UNSAVED_CHANGES_UNNAMED_INIT = "UNSAVED_CHANGES_UNNAMED_INIT";
export const UNSAVED_CHANGES_UNNAMED_SUCCESS =
  "UNSAVED_CHANGES_UNNAMED_SUCCESS";
export const UNSAVED_CHANGES_PROJECT_DETAILS_INIT =
  "UNSAVED_CHANGES_PROJECT_DETAILS_INIT";
export const UNSAVED_CHANGES_PROJECT_DETAILS_SUCCESS =
  "UNSAVED_CHANGES_PROJECT_DETAILS_SUCCESS";
export const UNSAVED_CHANGES_GANTT_BY_DEP_INIT =
  "UNSAVED_CHANGES_GANTT_BY_DEP_INIT";
export const UNSAVED_CHANGES_GANTT_BY_DEP_SUCCESS =
  "UNSAVED_CHANGES_GANTT_BY_DEP_SUCCESS";
export const UNSAVED_CHANGES_GANTT_NOTIFICATIONS_INIT =
  "UNSAVED_CHANGES_GANTT_NOTIFICATIONS_INIT";
export const UNSAVED_CHANGES_GANTT_NOTIFICATIONS_SUCCESS =
  "UNSAVED_CHANGES_GANTT_NOTIFICATIONS_SUCCESS";
export const UNSAVED_CHANGES_GANTT_NOTIFICATIONS_UNNAMED_INIT =
  "UNSAVED_CHANGES_GANTT_NOTIFICATIONS_UNNAMED_INIT";
export const UNSAVED_CHANGES_GANTT_NOTIFICATIONS_UNNAMED_SUCCESS =
  "UNSAVED_CHANGES_GANTT_NOTIFICATIONS_UNNAMED_SUCCESS";
